export const environment = {
  name: 'dev',
  production: false,
  apiUrl: 'https://dev-crmsolutionapi.pl/api',
};
